<template>
    <div class="color-icon">
        <buttonc type="icon-overlay" v-bind:style="{background: color}" @click="OpenPicker"></buttonc>
    </div>
</template>

<script>
    export default {
        name: "colorpickicon",
        data() {
            return {
            }
        },
        props:{
            color: String,  //hex string
                            //'#996601'
            colorBlacklist: {type: Array, default() { return [] }},
                            //array of {color: '#996601', label: 'Service'}
                            //use label to indicate which spot is taking up the slot
            colorSelection: Array,
                            //array of hex strings or {dark: '#996601', light: 'dbc9a6'}
                            //works either way
        },
        methods: {
            OpenPicker(){
            
                let view = this;
                this.$helpers.OpenColorSelection(
                    (color) => {
                        view.$emit('Update', color);
                    },
                    {
                        colorSelected: this.color,
                        colorBlacklist: this.colorBlacklist,
                    },
                );
            },
        },
    }
</script>

<style scoped>
    .color-icon, .color-icon .button{
        height: 20px;
        width: 20px;
        border-radius: 100px;
        box-shadow: 0 0 1px var(--contrast-3);
    }
    
     .color-icon:hover .button, .color-icon .button.focus-highlight{
        filter: brightness(120%);
     }
</style>
